<template>
  <div class="d-flex flex-column-fluid flex-center mt-30 mt-lg-0">
    <div
      class="position-absolute top-0 right-0 text-right mt-5 mb-15 mb-lg-0 flex-column-auto justify-content-center py-5 px-10"
    >
      <span class="font-weight-bold font-size-3 text-dark-60">Вы уже зарегистрированы?</span>&nbsp;&nbsp;
      <router-link
        class="font-weight-bold font-size-3 ml-2"
        :to="{ name: 'login' }"
      >{{ $t("AUTH.GENERAL.SIGNIN_BUTTON") }}</router-link>
    </div>

    <div class="login-form login-signin">
      <div class="text-center mb-5">
        <h3 class="font-size-h1">{{ $t("AUTH.REGISTER.TITLE") }}</h3>
      </div>
      <v-alert type="error" :value="hasError">{{ errorMessage }}</v-alert>
      <v-form ref="form" v-model="valid" :lazy-validation="false">
        <v-autocomplete
          v-model="form.city_id"
          :items="cities"
          hide-no-data
          hide-selected
          item-text="name"
          item-value="id"
          label="Ваш город"
          placeholder="Выбрать город"
          :rules="cityRules"
        ></v-autocomplete>
        <v-text-field v-model="form.name" type="text" :rules="nameRules" label="Ваше Имя" required></v-text-field>
        <v-text-field
          v-model="form.phone"
          type="text"
          :rules="phoneRules"
          label="Номер телефона"
          required
        ></v-text-field>
        <v-text-field
          v-model="form.email"
          type="email"
          :rules="emailRules"
          label="Email"
          required
        ></v-text-field>
        <v-text-field
          v-model="form.password"
          type="password"
          :rules="passwordRules"
          label="Пароль"
          required
        ></v-text-field>
        <div class="d-flex align-center justify-space-between mt-5">
          <router-link :to="{name: 'login'}">Назад</router-link>
          <v-btn
            color="primary"
            @click="onSubmit"
            :loading="submitting"
          >{{ $t("AUTH.REGISTER.BUTTON") }}</v-btn>
        </div>
      </v-form>
    </div>
  </div>
</template>

<script>
import { REGISTER } from "@/core/services/store/auth.module";
import { LOGOUT } from "@/core/services/store/auth.module";

export default {
  name: "register",
  metaInfo: {
    title: "Регистрация",
  },
  data() {
    return {
      submitting: false,
      hasError: false,
      errorMessage: null,
      cities: [],
      valid: true,
      form: {
        name: "",
        phone: "",
        city_id: "",
        email: "",
        password: "",
        password_confirmation: "",
      },
      cityRules: [(v) => !!v || "не может быть пустым"],
      nameRules: [(v) => !!v || "не может быть пустым"],
      phoneRules: [(v) => !!v || "не может быть пустым"],
      emailRules: [
        (v) => !!v || "Email не может быть пустым",
        (v) => /.+@.+\..+/.test(v) || "Email должен быть валидным",
      ],
      passwordRules: [
        (v) => !!v || "не может быть пустым",
        (v) => v.length >= 8 || "минимальная длина пароля 8 символов",
      ],
    };
  },
  beforeMount() {
    this.$api.cities.select().then((response) => {
      this.cities = response.data.items;
    });
  },
  methods: {
    onSubmit() {
      if (this.$refs.form.validate()) {
        this.submitting = true;
        this.hasError = false;
        this.$store.dispatch(LOGOUT);

        this.$store
          .dispatch(REGISTER, {
            phone: this.form.phone,
            password: this.form.password,
            name: this.form.name,
            city_id: this.form.city_id,
            email: this.form.email,
            role: process.env.VUE_APP_ROLE,
          })
          .then(() => this.$router.push({ name: "vehicles" }))
          .catch((response) => {
            this.hasError = true;
            this.errorMessage = response.data.errors.base.join(", ");
          })
          .finally(() => (this.submitting = false));
      }
    },
  },
};
</script>
